module.exports = __webpack_public_path__ + "static/media/location.3e3c7f30.svg";